// extracted by mini-css-extract-plugin
export default {"subtitleBox":"CollapsingSubtitle_subtitleBox__y28ET"};